import React from 'react'
import {
  Col,
  Container,
  Row,
  Tooltip,
  Button,
  Icon,
  Tabs as ArchTabs,
  Accordion,
  AccordionRow,
  Table as PayPalTable,
  Toast,
  Badge,
  Banner,
  Alert,
  HeadingText,
} from '@paypalcorp/pp-react'
import ContentAccordion from '../../../../utils/ContentAccordion'
import TableBrandedLimitedRelease from './TableBrandedLimitedRelease'
import BrandedLimitedReleaseIntro from '../BrandedLimitedReleaseIntro'
import CardCurrencySpecialCurrencies from '../CardCurrencySpecialCurrencies'
import './accordion.css'

const TableBrandedLimitedReleaseAccordion = () => {
  return (
    <div>
      <BrandedLimitedReleaseIntro />
      <ContentAccordion>
        <AccordionRow
          heading="Branded currency table"
          className="accordion-height-acdc"
        >
          <TableBrandedLimitedRelease />
        </AccordionRow>
      </ContentAccordion>
      <CardCurrencySpecialCurrencies />
    </div>
  )
}

export default TableBrandedLimitedReleaseAccordion
